import React from "react";
import AppRoutes from "./router/router";
import { ToastContainer } from "react-toastify";
import mixpanel from 'mixpanel-browser';
import "react-toastify/dist/ReactToastify.css";  

import "./App.css";
const MIXPANEL_ID = `${process.env.REACT_APP_MIXPANEL_TOKEN}`;

function App() {
  mixpanel.init(MIXPANEL_ID, { api_host: process.env.REACT_APP_MIXPANEL_API_HOST }); 
  return (
    <>
    <ToastContainer />  
    <div className="container">
      <AppRoutes />
    </div>
    </>
  );
}

export default App;
